import { Pack, RePack } from 'types';
import { RoutePaths, PackType, RePackSubType, QueryParams } from 'types/enums';
import { getPartOfCurrentQueryString } from './getPartOfCurrentQueryString';

export function getPackRouteEntityPath(item: Pack | RePack): RoutePaths {
    if (
        item.type === PackType.RePack &&
        (item as RePack).subType === RePackSubType.Chart
    ) {
        return RoutePaths.Charts;
    }

    if (item.type === PackType.RePack) {
        return RoutePaths.RePacks;
    }

    return RoutePaths.Packs;
}

export function getPackLinkPath(item: Pack | RePack): string {
    const entityPath = getPackRouteEntityPath(item as Pack | RePack);

    // There's always only 1 tab on pack/repack details page - samples
    // so, to avoid errors when coming from `?tab=Pack`
    // we remove the tab query param
    const queryString = `?${getPartOfCurrentQueryString({
        routerQueryString: window.location.search,
        queriesToExclude: [QueryParams.tab, QueryParams.page],
    })}`;

    return `/${entityPath}/${item.slug}${queryString}`;
}
